(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneDetailController', BlockedPhoneDetailController);

    /* Added UIFormAccess
    BlockedPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BlockedPhone', 'PhoneCallResult', 'User', 'Employee'];

    function BlockedPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, BlockedPhone, PhoneCallResult, User, Employee) {
    */
    BlockedPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BlockedPhone', 'PhoneCallResult', 'User', 'Employee', 'UIFormAccess'];

    function BlockedPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, BlockedPhone, PhoneCallResult, User, Employee, UIFormAccess) {
        var vm = this;

        vm.blockedPhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:blockedPhoneUpdate', function(event, result) {
            vm.blockedPhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
